<div class="dialog">
  @if (isMobileView()) {
    <header class="mobile-app-bar sticky-header">
      <p (click)="close()" class="task-header-action" translate>Cancel</p>
      <h2 class="mobile-app-bar__heading">{{ 'Information about the course' | translate }}</h2>
    </header>
  }

  @if (!isMobileView()) {
    <header class="dialog__header">
      <h3 class="dialog__header__title">{{ 'Information about the course' | translate }}</h3>
      <div class="dialog__header__action-buttons">
        @if ((isUserAdmin || isUserAuthor) && !isLoading) {
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="editCourse(this.course)" [cssStyle]="{ margin: '4px' }" iconName="pencil" size="20px"></app-icon>
            </span>
          </div>
          <div class="dialog__header__action-buttons__button">
            <span>
              <app-icon (click)="deleteCourse(this.course)" [cssStyle]="{ margin: '4px' }" iconName="trash-bin" size="20px"></app-icon>
            </span>
          </div>
        }
        <div (click)="close()" class="dialog__header__action-buttons__button">
          <span>
            <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="20px"></app-icon>
          </span>
        </div>
      </div>
    </header>
  }

  <div class="dialog__content">
    @if (!isLoading && course?.name && alertType) {
      <div [class]="{ 'px-16': isMobileView }">
        <app-alert-message [alertType]="alertType" [denyReason]="course?.denyReason" [showCloseIcon]="false" size="small" marginTop="20px"></app-alert-message>
      </div>
    }

    <div class="flex-row-start gap-14">
      <div class="main-course-details">
        <div class="tab-selection-filters">
          <!--        <app-tabs-selection (selectedTab)="currentTabRoute = $event" [tabs]="[{ label: 'description' | translate, displayName: 'description' }, { label: 'instructor' | translate,  displayName: 'Instructor' }, { label: 'participants' | translate, displayName: '' },{ label: 'roomInfo' | translate, displayName: 'Room Info'}, { label: 'taskDetails' | translate, displayName: 'Task Details'}]"></app-tabs-selection>-->
          <app-dynamic-tabs>
            <ng-template [tabName]="'Description' | translate">
              @if (!isLoading && course) {
                <div class="courses">
                  <h2 class="courses__title">{{ course.name }}</h2>
                  <p [innerHTML]="course.description" class="courses__description">{{ course.description }}</p>
                  @if (course.document) {
                    <div class="mt-20">
                      <app-button
                        (clickEvent)="downloadDocument(course, $event)"
                        [idleText]="'Download Attachment' | translate"
                        [prefixIconName]="'download'"
                        iconColor="var(--white)"
                        iconSize="16px"
                      ></app-button>
                    </div>
                  }
                </div>
              } @else {
                <ngx-skeleton-loader
                  [theme]="{
                    height: '60px',
                    width: '100%',
                  }"
                  count="1"
                ></ngx-skeleton-loader>
                <ngx-skeleton-loader
                  [theme]="{
                    height: '350px',
                    width: '100%',
                  }"
                  count="1"
                ></ngx-skeleton-loader>
              }
            </ng-template>

            <ng-template [tabName]="'Instructor' | translate">
              <app-course-instructor [instructor]="instructor" [showHeader]="false"></app-course-instructor>
            </ng-template>

            <ng-template [tabName]="'Participants' | translate">
              <app-course-participants [approvedParticipants]="approvedFilteredCourseUsers" [organizer]="course.user" [unapprovedParticipants]="unApprovedCourseUsers"></app-course-participants>
            </ng-template>

            <ng-template [tabName]="'Room Info' | translate">
              <app-course-room [isOpenedInDialog]="false" [room]="room"></app-course-room>
            </ng-template>

            @if (course?.courseTask && course.courseTask.id) {
              <ng-template [tabName]="'Task Details' | translate">
                <app-course-task [task]="course.courseTask"></app-course-task>
              </ng-template>
            }
          </app-dynamic-tabs>
        </div>
      </div>

      <div class="course-card-details">
        <div class="card">
          @if (!isLoading && course) {
            <div class="image-wrapper background-loading">
              <img [src]="course?.imageUrl" alt="" appDefaultImage="assets/images/defaults/course.png" />
              <app-badge [text]="instructorType | translate" [type]="'gradient'" borderRadius="6px" positionBottom="10px" positionLeft="12px"></app-badge>
            </div>
            <div>
              <div class="card-body">
                <div class="flex-row-between-center mt-24">
                  <h3 class="card__title">{{ +course.pricePerParticipant ? '€ ' + course.pricePerParticipant : ('Free' | translate) }}</h3>
                  @if (isCourseFullyBooked) {
                    <app-badge [text]="'Booked Out' | translate" class="card-text badge" size="14px"></app-badge>
                  } @else {
                    <app-badge [text]="('Occupancy' | translate) + ':' + (availabilityCount || 0) + '/' + course.allowedPersons" class="card-text badge" size="14px"></app-badge>
                  }
                </div>
                @if (isUserInvited) {
                  <div class="flex-row-center-center gap-10 mt-25">
                    <!--  Accept course invitation -->
                    <app-button (clickEvent)="acceptCourse($event)" [idleText]="'Accept' | translate" iconColor="var(--white)" iconSize="18px" prefixIconName="add"></app-button>
                    <!--  Deny course invitation  -->
                    <app-button (clickEvent)="denyCourse($event)" [idleText]="'Deny' | translate" cssClass="button-simple" iconSize="18px" prefixIconName="user-leave-fill"></app-button>
                  </div>
                }
                <div class="card-info-list">
                  <h2 class="card-info-list__subheading" translate>Further information about the course</h2>
                  <div class="card-info-list__item">
                    <app-icon color="var(--orange)" iconName="user" marginBottom="-3px" size="16px"></app-icon>
                    <label>{{ 'Instructor' | translate }}:</label>
                    <p>{{ instructor?.fullName }}</p>
                  </div>
                  <div class="card-info-list__item">
                    <app-icon color="var(--orange)" iconName="marker" marginBottom="-3px" size="16px"></app-icon>
                    <label>{{ 'Place' | translate }}:</label>
                    <p>{{ course.place }}</p>
                  </div>
                  <div class="card-info-list__item">
                    <app-icon color="var(--orange)" iconName="calendar" marginBottom="-3px" size="16px"></app-icon>
                    <label>{{ 'Date' | translate }}:</label>
                    <p>{{ ((currentDate | friendlyDate: true : true) ?? getRecurrenceInfo) || (course.courseRecurrence[0]?.dateFrom | friendlyDate: true : true) }}</p>
                  </div>
                  <div class="card-info-list__item">
                    <app-icon color="var(--orange)" iconName="clock" marginBottom="-3px" size="16px"></app-icon>
                    <label>{{ 'Time' | translate }}:</label>
                    <p>
                      {{ course.startTime }} - {{ course.endTime }}
                      <span translate>Clock</span>
                    </p>
                  </div>
                  @if (course?.courseTagsArray && course.courseTagsArray.length) {
                    <div class="card-info-list__item">
                      <app-icon color="var(--orange)" iconName="hash" size="16px"></app-icon>
                      <label>{{ 'Tags' | translate }}:</label>
                      @for (tag of course.courseTagsArray; track tag) {
                        <p class="tag tag-display mr-1">{{ tag | humanize | truncateText: 30 }}</p>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          } @else {
            <ngx-skeleton-loader
              [theme]="{
                height: '250px',
                width: '100%',
              }"
              count="1"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              [theme]="{
                height: '40px',
                width: '100%',
              }"
              count="1"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              [theme]="{
                height: '25px',
                width: '100%',
              }"
              count="5"
            ></ngx-skeleton-loader>
          }
        </div>
      </div>
    </div>
  </div>

  <!--  <footer>-->
  <!--    <div class="dialog__footer">-->
  <!--      <div *ngIf="!isMobileView()" class="dialog__footer__buttons">-->
  <!--        <app-button (click)="close()" [idleText]="'Cancel' | translate"-->
  <!--                    [inlineStyle]="{ border: '1px solid var(&#45;&#45;gray)' }" cssClass="button-simple"></app-button>-->
  <!--        <app-button [idleText]="'Save' | translate"></app-button>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--    <div *ngIf="isMobileView()" class="mobile-button mx-16 mb-34">-->
  <!--      <app-button-->
  <!--        [idleText]="'Save' | translate"-->
  <!--        cssClass="button-primary button-full"-->
  <!--      ></app-button>-->
  <!--    </div>-->
  <!--  </footer>-->
</div>
